import { Text } from '@atoms/index';
import { opportunitiesGaEventsName } from '@helpers/ga-events-name-enum';
import { triggerCustomGaEvent } from '@helpers/miscelleanous';
import { Modal } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { useEffect, useState } from 'react';
import { getOpenConfigurations } from '@services/configuration.service';
import { configurationEntityTypes } from '@helpers/enums/configuration-enums';
import { isValidResponseEntity } from '@helpers/utils';
import { isValidJSON } from '@helpers/miscelleanous';

const RbiRegulatedSdiNoteModal = ({ show, onClose }) => {
    const [aboutSdi, setAboutSdi] = useState(null);

    useEffect(() => {
        getNoteData();
        triggerCustomGaEvent(opportunitiesGaEventsName.VIEWED_RBI_SDI_POPUP);
    }, [])

    const getNoteData = async () => {
        try {
            const response = await getOpenConfigurations(configurationEntityTypes.ABOUT_SDI);
            if (isValidResponseEntity(response) && response?.entity?.length) {
                const value = response?.entity?.[0].value;
                if (isValidJSON(value)) {
                    const aboutSdiJson = JSON.parse(value);
                    setAboutSdi(aboutSdiJson);
                }
            }
        } catch (error) { }
    };

    if (aboutSdi?.length > 0)
        return (
            <Modal
                show={show}
                onClose={onClose}
                width="md:w-[400px] sm:w-1/2 max-w-screen-lg"
                height="h-70"
                label={"RBI Regulated SDIs"}
                labelClassName='p3-semibold text-primary-500'
                labelPadding='py-3 px-4'
                paddingClass='pt-3 pb-4 px-4'
                labelSize={' '}
                children={
                    <div className=''>
                        <ul className='list-disc text-gray-500 p4-regular pb-5 pl-4'>
                            {aboutSdi.map((note, index) =>
                                <li key={index}><Text content={note} /></li>)
                            }
                        </ul>
                        <Button buttonSize='medium' buttonText='OK, Understood' onClick={onClose} widthClass={"w-full"} />
                    </div>
                }
            />
        );
    else return null;
}

export default RbiRegulatedSdiNoteModal;
